import React, { use, useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { setRowsU, setPageU, setMaxPagesU, setSortingU, setCheckedItemU, toggleAddModalU, toggleEditModalU, toggleCheckedItemU } from '../../../store/opinionsUTabSlice.js';
import {
  getHeaders,
  headerWidths,
  tabsConfig,
  buttonsConfig,
  leftSideConfig,
  rightSideConfig,
  empty,
  sortButtonsConfig,
} from './opinionsTableConfigAboutUsers.js';
import Table from '../../../components/list2/table';
import Pagination from '../../../components/components/pagination/pagination.jsx';
import { fetchOpinionsU } from './opinionsUTableService';
import UnisersalLineWithComponents
  from "../../../components/components/universal_line_with_components/universalLineWithComponents";
import { ReactComponent as StarFilled } from '../../../components/icons/star-filled.svg';
import { ReactComponent as StarEmpty } from '../../../components/icons/star-empty.svg';

function OpinionsU() {

  const dispatch = useDispatch(); 

  const activeTab = useSelector((state) => state.opinions.activeTab);

  const totalPagesU = useSelector((state) => state.opinionsU.maxPages);
  const currentPageU = useSelector((state) => state.opinionsU.currentPage);
  const sortByU = useSelector((state) => state.opinionsU.sortBy);
  const sortDirectionU = useSelector((state) => state.opinionsU.sortDirection);
  const checkedItemsU = useSelector((state) => state.opinionsU.checkedItems);
  const addModalOpenU = useSelector((state) => state.opinionsU.addModalOpen);
  const editModalOpenU = useSelector((state) => state.opinionsU.editModalOpen);
  const keywordU = useSelector((state) => state.opinionsU.keyword);
  const searchValueU = useSelector((state) => state.opinionsU.searchValue);
  const sortSortListEndpointU = useSelector((state) => state.opinionsU.sortSortListEndpoint);
  const rowsU = useSelector((state) => state.opinionsU.rows);
  const needRefreshU = useSelector((state) => state.opinionsU.needRefresh);

  const sortArrowColorActive = '#060606';
  const sortArrowColorInactive = '#06060650';

  useEffect(() => {
    fetchOpinionsU(sortByU, sortDirectionU, keywordU, currentPageU, dispatch, checkedItemsU);
    // eslint-disable-next-line react-hooks/rules-of-hooks
  }, [currentPageU, sortByU, sortDirectionU, checkedItemsU, needRefreshU, keywordU]);

  const renderedRows = rowsU.map((row) => [
    <input
        type="checkbox"
        checked={row.checked}
        onChange={() => dispatch(toggleCheckedItemU(row.id))}
    />,
    row.id,
    row.addedOn,
    row.userName,
    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%'

    }}>
      {[...Array(row.scoreLevel)].map((_, index) => (
          <StarFilled />
      ))}
      {[...Array(5 - row.scoreLevel)].map((_, index) => (
          <StarEmpty />
      ))}
    </div>,
    row.senderName,
  ]);


  let headers = getHeaders (
      sortByU,
      sortDirectionU,
      dispatch,
      setSortingU,
      sortArrowColorActive,
      sortArrowColorInactive,
      rowsU,
      checkedItemsU) ;

    const paginationProps = {
      reduxSelector: (state) => state.opinionsU.currentPage,
      reduxAction: setPageU,
      totalPages: totalPagesU,
      maxVisibleButtons: 5,
    };
    
    const rightSideConfig2 = [
      {
        component: Pagination, // Komponent do wyrenderowania
        props: paginationProps, // Właściwości przekazywane do komponentu
      },
    ];

  return (
    <div className="table-container">
      <Table
        headers={headers}
        rowsClass='row-sports'
        cellClass='cell-sports'
        rows={renderedRows}
        columnWidths={headerWidths}
        idViewing={true}
        idArrayId={1}
        cellClass2='cell-center'
        cellClass2ConditionList={[1, 4, 5, 6]} />
      <UnisersalLineWithComponents leftSide={empty} rightSide={rightSideConfig2} />
    </div>
  );
}

export default OpinionsU;